// extracted by mini-css-extract-plugin
var _1 = "AttachmentContainer-module__animateUploadProgressBarWidth--l8BxP";
var _2 = "AttachmentContainer-module__animatedBackground--RQRMT";
var _3 = "AttachmentContainer-module__attachmentArea--o2APb";
var _4 = "AttachmentContainer-module__attachmentAreaContainer--eDHXN";
var _5 = "AttachmentContainer-module__attachmentGrid--fHOK2";
var _6 = "70px";
var _7 = "AttachmentContainer-module__container--KxToN";
var _8 = "AttachmentContainer-module__hasOpenMenu--UazUp";
var _9 = "AttachmentContainer-module__header--BIjB8";
var _a = "AttachmentContainer-module__isExpanded--l7H19";
var _b = "AttachmentContainer-module__meta--nPzJH";
var _c = "AttachmentContainer-module__narrow--PH7p6";
var _d = "AttachmentContainer-module__placeholder--AlBNV";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "attachmentArea", _4 as "attachmentAreaContainer", _5 as "attachmentGrid", _6 as "collapsedHeight", _7 as "container", _8 as "hasOpenMenu", _9 as "header", _a as "isExpanded", _b as "meta", _c as "narrow", _d as "placeholder" }
